<div class="mbb-container">
  <app-add-product-button
    buttonText="Legg til nytt mobilt bredbånd"
    class="add-mbb-button"
    testId="add-new-mbb-button"
    [iconName]="IconNames.ice_mbb"
    [isDisabled]="
      (isLoadingProducts$ | async) || ((hasPerformedAllowanceCheck$ | async) && !(isMbbAllowanceCheckSuccessful$ | async))
    "
    (add)="onAddMbbProduct()"
  />

  @if (mbbProducts.length === 0) {
    <app-ice-card type="neutral">
      <div class="no-mbb-products-container">Nye avtaler vil dukke opp her.</div>
    </app-ice-card>
  }
  @if (form) {
    <form ngxsForm="formState.mbbForm" [formGroup]="form">
      <app-accordion class="accordions">
        @for (item of list; track item; let i = $index) {
          <app-accordion-group formArrayName="list">
            <app-accordion-header
              testId="mbb-accordion-button"
              [disabled]="mbbProducts[i]?.isExistingSubscription"
              [icon]="IconNames.ice_mbb"
              [isOpen]="(selectedMbbSubscriptionId$ | async) === mbbProducts[i]?.id"
              [message]="
                !item.status || item.status === FormStatus.PENDING
                  ? ''
                  : (item.valid || (item.statusChanges | async) === FormStatus.VALID) &&
                      item.controls.interactedSteps?.value?.length > 0
                    ? 'Ferdig registrert'
                    : 'Ikke ferdig registrert'
              "
              [messageType]="
                (item.valid || (item.statusChanges | async) === FormStatus.VALID) &&
                item.controls.interactedSteps?.value?.length > 0
                  ? MessageType.success
                  : (selectedMbbSubscriptionId$ | async) === mbbProducts[i]?.id
                    ? MessageType.neutral
                    : MessageType.error
              "
              [showMenu]="true"
              (toggleAccordion)="onToggleAccordion($event, mbbProducts[i].id, item)"
            >
              <span class="mbb-header-title">
                {{
                  (mbbProducts[i].mbbSubscription?.name || '') +
                    ((mbbProducts[i].mbbRouter?.name && mbbProducts[i].mbbSubscription?.name && ', ') || '') +
                    (mbbProducts[i].mbbRouter?.name || '')
                }}
              </span>
              <div menu-content>
                <button data-testid="remove-mbb-product-button" mat-menu-item (click)="onRemoveMbbProduct(mbbProducts[i])">
                  <span>Slett</span>
                </button>
              </div>
            </app-accordion-header>
            <app-accordion-content [isOpen]="(selectedMbbSubscriptionId$ | async) === mbbProducts[i]?.id">
              <ng-template appAccordionLazy>
                <div class="mbb-content-container" [formGroup]="item">
                  <app-ice-stepper
                    #stepper
                    [hasCustomNavigation]="false"
                    [interactedSteps]="item.controls.interactedSteps?.value || []"
                    [selectedIndex]="(selectedMbbStepIndex$ | async) || 0"
                    (isFinished)="closeAccordion(mbbProducts[i].id, item)"
                    (selectionChange)="onStepChange($event, i, item)"
                  >
                    <cdk-step label="Abonnement" [completed]="!mbbSubscriptionHasError" [hasError]="mbbSubscriptionHasError">
                      @if ((isLoadingMbbProducts$ | async) || (isLoadingMbbRouters$ | async)) {
                        <app-spinner />
                      } @else {
                        <app-mbb-subscription
                          [mbbAllowedOfferings]="mbbAllowedOfferings"
                          [mbbProduct]="mbbProducts[i]"
                          (isInvalid)="onMbbSubscriptionHasError($event)"
                          (mbbSubscriptionChange)="onMbbSubscriptionChange(mbbProducts[i], $event)"
                        />
                      }
                      <div class="step-navigation">
                        <app-ice-button
                          color="secondary"
                          testId="mbb-subscription-next-button"
                          (click)="stepper.next()"
                        >
                          Neste
                        </app-ice-button>
                      </div>
                    </cdk-step>
                    <cdk-step
                      label="Ruter"
                      [completed]="!mbbDeliveryHasError && !mbbUserDetailsHasError"
                      [hasError]="mbbDeliveryHasError || mbbUserDetailsHasError"
                    >
                      @if (isLoadingMbbRouters$ | async) {
                        <app-spinner />
                      } @else {
                        <app-mbb-select-router
                          [allowSubscriptionOnlyWithBinding]="allowSubscriptionOnlyWithBinding"
                          [canSellHardwareInPhysicalStore]="allowManualRegistrationClaim$ | async"
                          [canSellHardwareWithLogisticsClaim]="canSellHardwareWithLogisticsClaim$ | async"
                          [canSellMBBSubscriptionOnlyClaim]="canSellMBBSubscriptionOnlyClaim$ | async"
                          [mbbProduct]="mbbProducts[i]"
                          [mbbRouters]="mbbRouters$ | async"
                          [warehouseState]="warehouseState$ | async"
                          (isInvalid)="onMbbRouterHasError($event)"
                          (mbbDeliveryChange)="onMbbDeliveryChange(mbbProducts[i], i, $event)"
                          (mbbRouterChange)="onMbbRouterChange(mbbProducts[i], $event)"
                          (mbbRouterDetailsIccChanged)="updateMbbRouterIcc($event, mbbProducts[i])"
                          (mbbRouterDetailsImeiChanged)="updateMbbRouterImei($event, mbbProducts[i])"
                          (orderSimChange)="onOrderSimChange(mbbProducts[i], $event)"
                        />
                        @if (mbbProducts[i].deliveryOption !== MbbDeliveryOptions.AlreadyOwnRouter) {
                          <app-mbb-user-details
                            [mbbProduct]="mbbProducts[i]"
                            (isInvalid)="onMbbUserDetailsHasError($event)"
                            (mbbUserDetailsFormChange)="updateMbbRouterName($event, mbbProducts[i])"
                          />
                        }
                      }
                      <div class="step-navigation">
                        <app-ice-button color="outlined" testId="step-back-mbb-button" (click)="stepper.previous()">
                          Tilbake
                        </app-ice-button>
                        <app-ice-button
                          color="secondary"
                          testId="mbb-router-next-button"
                          (click)="stepper.next()"
                        >
                          Neste
                        </app-ice-button>
                      </div>
                    </cdk-step>

                    <cdk-step label="Startdato" [completed]="!activationDateHasError" [hasError]="activationDateHasError">
                      <app-mbb-activation-date
                        (activationDateChange)="updateMbbActivationDate($event, mbbProducts[i])"
                        (isInvalid)="activationDateHasError = $event"
                      />
                      <div class="step-navigation">
                        <app-ice-button color="outlined" testId="step-back-mbb-button" (click)="stepper.previous()">
                          Tilbake
                        </app-ice-button>
                        <app-ice-button
                          color="primary"
                          testId="add-mbb-accordion-finished-button"
                          (click)="closeAccordion(mbbProducts[i].id, item)"
                        >
                          Ferdig
                        </app-ice-button>
                      </div>
                    </cdk-step>
                  </app-ice-stepper>
                </div>
              </ng-template>
            </app-accordion-content>
          </app-accordion-group>
        }
      </app-accordion>
    </form>
  }

  <div class="existing-mbb-subscriptions-title">Kundens abonnementer</div>

  @for (inFlightMbbOrder of inFlightMbbOrders$ | async; track inFlightMbbOrder) {
    <div>
      <app-customer-agreement iconName="ice_mbb" [isInFlightOrder]="true" [mainHeading]="inFlightMbbOrder.description">
        <app-ice-badge type="neutral">Under behandling</app-ice-badge>
      </app-customer-agreement>
    </div>
  }

  @if (isLoadingProducts$ | async) {
    <app-spinner />
  } @else {
    @if (existingMbbProducts.length === 0) {
      <app-ice-alert type="neutral" [iconName]="IconNames.ice_info">Ingen eksisterende MBB produkter.</app-ice-alert>
    } @else {
      <app-accordion class="accordions">
        @for (product of existingMbbProducts; track product.id; let i = $index) {
          <app-accordion-group data-testid="existing-mbb-subscription">
            <app-accordion-header
              testId="existing-mbb-accordion-button"
              [icon]="IconNames.ice_mbb"
              [isOpen]="(selectedMbbSubscriptionId$ | async) === existingMbbProducts[i]?.id"
              [message]="product.mbbSubscription?.id ? 'Abonnement endret' : ''"
              [showMenu]="true"
              (toggleAccordion)="onToggleAccordion($event, product.id)"
            >
              <div class="existing-header">
                <div class="header-information">
                  <div>
                    <span class="mbb-header-title">{{ product.existingSubscription.userName }}</span>
                    {{
                      product.mbbSubscription?.id ? product.mbbSubscription.name : product.existingSubscription?.productName
                    }}
                  </div>
                  @if (SubscriptionHelperService.getFutureBindingExpirationDate(product); as expirationDate) {
                    <div class="mbb-header-binding">
                      <span>Avtaletid til&nbsp;</span>
                      <span class="binding-period">{{ expirationDate | date: 'dd.MM.yyyy' }}</span>
                    </div>
                  } @else {
                    <div class="mbb-no-binding">Ingen avtaletid</div>
                  }
                </div>
                @if (product.mbbSubscription?.id) {
                  <span class="header-price">
                    {{ product.mbbSubscription?.monthlyPrice?.price?.includingVAT | priceFormat: PriceType.Monthly }}
                  </span>
                } @else {
                  <span class="header-price">
                    {{ product.assignedSubscription?.monthlyCost?.includingVAT | priceFormat: PriceType.Monthly }}
                  </span>
                }
              </div>
              <div menu-content>
                <button
                  data-testid="open-mbb-product-in-manny-button"
                  mat-menu-item
                  [disabled]="!product.existingSubscription.customerId || !product.existingSubscription.id"
                  (click)="toManny(product)"
                >
                  <span>Åpne i Manny</span>
                </button>
              </div>
            </app-accordion-header>
            <app-accordion-content [isOpen]="(selectedMbbSubscriptionId$ | async) === existingMbbProducts[i]?.id">
              <ng-template appAccordionLazy>
                <app-mbb-existing-subscription [product]="product" />
              </ng-template>
            </app-accordion-content>
          </app-accordion-group>
        }
      </app-accordion>
    }
  }
</div>
